module.exports = __webpack_public_path__ + "media/images/gallery/gal_m-87c242168c028ee271a1391ffef8879d.gif";